import gapPage from 'sites/enroll.pivothealth.com/census/components/gapPage'
import setUpDiscoveryProcess from '../components/discovery-process'
import scrollTo from 'core/DOM/scrollTo'
import Router from 'vanilla-router'
import showStep from '../showStep'

let $form = null

function isValidStep1(controllers) {
  let isValidForm = true
  const step1Controls = (({ zip, gender }) => ({ zip, gender }))(controllers)

  for (const key in step1Controls) {
    const status = step1Controls[key].getStatus()
    isValidForm = isValidForm && status.valid
  }

  return isValidForm
}

function setUpRouter(controllers) {
  $form = $('#form')
  const router = new Router({
    mode: 'history',
    root: '/census/',
    page404: function () {
      showStep('step1')
    }
  })
  router
    .add('', function () {
      showStep('step1')
    })
    .add('over65', () => {
      showStep('step-over65')
      gapPage('over65')
    })
    .add('no-coverage', () => {
      showStep('step-no-coverage-gap')
      gapPage('step-no-coverage-gap')
    })
    .add('uhc-state', () => {
      showStep('step-uhc-state')
      gapPage('step-uhc-state')
    })
    .add('customize-short-term-health-insurance', () => {
      const isValidForm = isValidStep1(controllers)

      if (isValidForm) {
        setUpDiscoveryProcess()
        showStep('step-dcp')
      } else {
        router.navigateTo('')
      }
    })
    .addUriListener()

  return router
}

export default setUpRouter
